import { render, staticRenderFns } from "./ChangePasswordScreen.vue?vue&type=template&id=529cd86e&"
import script from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports